import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './ui/__generated__/uiFeaturesPlansSettingsQuery$parameters';

const toPlanAri = ({
	siteId,
	activationId,
	planId,
}: {
	siteId: string;
	activationId: string;
	planId: string;
}): string => {
	return `ari:cloud:jira:${siteId}:plan/activation/${activationId}/${planId}`;
};

export const featuresEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-plan-features-entrypoint" */ './ui/index.tsx'),
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => {
		return {
			queries: {
				plan: {
					variables: {
						planId: toPlanAri({
							siteId: tenantContext.cloudId,
							activationId: tenantContext.activationId,
							planId: String(match.params.planId),
						}),
						releasesFeatureGateEnabled: fg('simple-plans-m2-release-feature-toggle'),
						planSettingRefreshEnabled: fg('plan_settings_refresh'),
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
					parameters,
				},
			},
		};
	},
});
